import React from "react";
import s from "./Card.module.scss";

const Card = ({ style, children }) => {
  return (
    <div style={style} className={s.cardContainer}>
      {children}
    </div>
  );
};

export default React.memo(Card);
